import React, { Component, Fragment } from "react";
const config = require("../config.json");

export default class Image extends Component {
  state = {
    isEditMode: false,
  };

  render() {
    return (
      <div className="tile is-near-half is-flex m-small box notification">
        <Fragment>
          <button
            onClick={(event) => {
              if (window.confirm("Sikker?")) {
                this.props.handleDeleteImage(event, this.props.image.Key);
              }
            }}
            className="delete"
          ></button>
        </Fragment>

        <div>
          <p className="product-id d-flex flex-column">
            <b>ID: {this.props.image.Key}</b>
            <img
              onMouseOver={() => {
                document.getElementById(
                  "fullimg_" + this.props.image.Key
                ).style.display = "block";
              }}
              onMouseOut={() => {
                document.getElementById(
                  "fullimg_" + this.props.image.Key
                ).style.display = "none";
              }}
              className="activity-image"
              src={`${
                config.s3.bucketUrls[this.props.bucketName] +
                this.props.image.Key
              }`}
            />
            <img
              id={`fullimg_${this.props.image.Key}`}
              style={{
                position: "absolute",
                zIndex: 2,
                display: "none",
                pointerEvents: "none",
                border: "2px solid black",
                backgroundColor: "white",
              }}
              src={`${
                config.s3.bucketUrls[this.props.bucketName] +
                this.props.image.Key
              }`}
            />
          </p>
        </div>
      </div>
    );
  }
}
